export default "__VITE_ASSET__AZHO3o8h__"